import { render } from "./PostInvoice.vue?vue&type=template&id=0c65ed8b&scoped=true"
import script from "./PostInvoice.vue?vue&type=script&lang=js"
export * from "./PostInvoice.vue?vue&type=script&lang=js"

import "./PostInvoice.vue?vue&type=style&index=0&id=0c65ed8b&scoped=true&lang=css"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c65ed8b"]])

export default __exports__